import { useEffect } from 'react';

/** Brand suffix shared by every page title; matches index.html's default. */
const BASE_TITLE = 'Loupe — Chemical Dependency Lab';

/**
 * Set `document.title` for the lifetime of a page.
 *
 * Pass a page-specific label (e.g. "Orders", "#CDL1113") and the hook renders
 * it as `"<label> · Loupe — Chemical Dependency Lab"`, restoring the base title
 * on unmount. Without a label the base title is used as-is. This makes tabs,
 * history entries, and bookmarks distinguishable instead of all reading the
 * same brand string.
 */
export function usePageTitle(label?: string | null): void {
  useEffect(() => {
    document.title = label ? `${label} · ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [label]);
}
